import { FC, ReactNode } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps, To } from 'react-router-dom';

import cn from 'classnames';

import styles from './Link.module.scss';

interface ILinkProps extends Omit<RouterLinkProps, 'to' | 'children'> {
	to?: To;
	href?: string;
	theme?: 'grey' | 'black' | 'brand' | 'blue';
	children: ReactNode | Record<string, string>;
}

export const Link: FC<ILinkProps> = ({ className, children, href, to, theme = 'brand', ...props }) => {
	if (href) {
		return (
			<a {...props} href={href} className={cn(className, styles.link, styles[theme])}>
				{children as ReactNode}
			</a>
		);
	}

	if (to) {
		return (
			<RouterLink {...props} to={to} className={cn(className, styles.link, styles[theme])}>
				{children as ReactNode}
			</RouterLink>
		);
	}
};
